export const NAVIGATE_HUB = 'navigate-hub';
